import { Schema } from "effect";
export const GenericLink = Schema.Struct({
    iId: Schema.String,
    genericLink: Schema.String,
    shortId: Schema.optional(Schema.String),
    uId: Schema.optional(Schema.String),
});
